import { and, eq, isNotNull, sql } from 'drizzle-orm'
import { cosineDistance } from 'drizzle-orm/sql/functions/vector'
import { db as defaultDb } from '@/db'
import { knowledgeEntries } from '@/db/schema'
import { buildKnowledgeEmbedding } from '@/lib/knowledge'
import type { PostgresJsDatabase } from 'drizzle-orm/postgres-js'
import type * as schema from '@/db/schema'

type DB = PostgresJsDatabase<typeof schema>

export type KnowledgeSearchResult = {
  id: string
  slug: string
  title: string
  bodyMarkdown: string
  score: number
}

export async function searchKnowledgeEntries(
  input: { tenantId: string; query: string; limit?: number },
  options?: { db?: DB },
): Promise<KnowledgeSearchResult[]> {
  const db = (options?.db ?? defaultDb) as DB
  const embedding = buildKnowledgeEmbedding(input.query)
  const distance = cosineDistance(knowledgeEntries.embedding, embedding)

  return await db
    .select({
      id: knowledgeEntries.id,
      slug: knowledgeEntries.slug,
      title: knowledgeEntries.title,
      bodyMarkdown: knowledgeEntries.bodyMarkdown,
      score: sql<number>`1 - (${distance})`,
    })
    .from(knowledgeEntries)
    .where(and(eq(knowledgeEntries.tenantId, input.tenantId), isNotNull(knowledgeEntries.embedding), eq(knowledgeEntries.isDeleted, false)))
    .orderBy(distance)
    .limit(input.limit ?? 5)
}
